import { Input, SelectNew } from "@synthesis/shared-ui";

import { useCreateApplicationDictionariesContext } from "../../create-application-dictionaries-context";
import { toSelectItems } from "../../create-application-page.lib";
import { CreateApplicationFormField, CreateApplicationFormSection } from "../create-application-form-layout";

export const CrossingObjectCommonSection = () => {
  const { dictionaries } = useCreateApplicationDictionariesContext();

  return (
    <CreateApplicationFormSection title="Общая информация об объекте" required>
      <CreateApplicationFormField label="Наименование объекта" required>
        <Input name="projectName" placeholder='например: "Газопровод высокого давления №12", "КЛ-10 кВ участок А–Б"' />
      </CreateApplicationFormField>

      <CreateApplicationFormField label="Железная дорога (филиал РЖД)" required className="max-w-[33rem]">
        <SelectNew
          controlled
          controlledClear
          name="railway"
          placeholder="Выберите из списка"
          items={toSelectItems(dictionaries.railways)}
          required
          size="md"
        />
      </CreateApplicationFormField>
    </CreateApplicationFormSection>
  );
};
